import { ReactElement } from "react"

interface PanelStackContainerProps {
    children?: ReactElement[] | ReactElement
}

export const PanelStackContainer = ({ children }: PanelStackContainerProps) => {
    return (
        <div id="stack-container" data-tid="app-homepage" className="overflow-hidden">
            {children}
        </div>
    )
}

export default PanelStackContainer
